import { useRef, useState } from "react";
import { Camera, FileUp, UploadCloud } from "lucide-react";
import { Button } from "@/components/ui/button";
import { t } from "@/i18n";

export default function MenuDropzone({ onFile }) {
  const [drag, setDrag] = useState(false);
  const fileRef = useRef(null);
  const camRef = useRef(null);
  const pick = (files) => files?.[0] && onFile(files[0]);

  return (
    <div
      data-testid="menu-dropzone"
      onDragOver={(e) => { e.preventDefault(); setDrag(true); }}
      onDragLeave={() => setDrag(false)}
      onDrop={(e) => { e.preventDefault(); setDrag(false); pick(e.dataTransfer.files); }}
      className={`relative overflow-hidden rounded-2xl border-2 border-dashed p-6 text-center transition-colors sm:p-12 ${drag ? "border-emerald-500 bg-emerald-500/5" : "border-border bg-card/60"}`}
    >
      <div className="grid-bg pointer-events-none absolute inset-0 opacity-40 [mask-image:radial-gradient(ellipse_at_center,black,transparent_70%)]" />
      <div className="relative">
        <div className="mx-auto mb-4 hidden h-14 w-14 items-center justify-center rounded-2xl border bg-background sm:flex"><UploadCloud className="h-6 w-6 text-emerald-500" /></div>
        <p className="text-lg font-semibold">{t("common.importez_votre_carte")}</p>
        <p className="mt-1 text-sm text-muted-foreground"><span className="hidden sm:inline">{t("menuDropzone.glissez_deposez_ici_une")} </span><span className="sm:hidden">{t("menuDropzone.une")} </span>{t("menuDropzone.photo_jpg_png_ou_un_pdf_15_mo_max")}</p>
        <div className="mt-5 grid gap-2 sm:mx-auto sm:max-w-md sm:grid-cols-2">
          <Button size="lg" className="h-14 text-base sm:hidden" onClick={() => camRef.current?.click()} data-testid="menu-camera-btn"><Camera className="mr-2 h-5 w-5" />{t("menuDropzone.prendre_en_photo")}</Button>
          <Button size="lg" variant="outline" className="h-14 text-base sm:hidden" onClick={() => fileRef.current?.click()} data-testid="menu-file-btn-mobile"><FileUp className="mr-2 h-5 w-5" />{t("menuDropzone.photo_ou_pdf")}</Button>
          <Button size="lg" className="hidden sm:col-span-2 sm:inline-flex" onClick={() => fileRef.current?.click()} data-testid="menu-file-btn"><FileUp className="mr-2 h-4 w-4" />{t("common.choisir_un_fichier")}</Button>
        </div>
        <input ref={fileRef} type="file" accept="application/pdf,image/jpeg,image/png,image/webp,image/heic,.heic,.heif,.pdf" className="hidden" data-testid="menu-file-input" onChange={(e) => { pick(e.target.files); e.target.value = ""; }} />
        <input ref={camRef} type="file" accept="image/*" capture="environment" className="hidden" data-testid="menu-camera-input" onChange={(e) => { pick(e.target.files); e.target.value = ""; }} />
      </div>
    </div>
  );
}
